import { Save } from "lucide-react";
import { Button } from "../../ui/button.tsx";

function SaveBotton({ handleSave, isSaving, disabled = false }: { handleSave: () => void, isSaving: boolean, disabled?: boolean }) {
  return (
    <div className="flex space-x-2 pt-6">
      <Button onClick={handleSave} disabled={isSaving || disabled}>
        <Save className="h-4 w-4 mr-2" />
        {isSaving ? 'Saving...' : 'Save Changes'}
      </Button>
    </div>
  )
}

export default SaveBotton